@if (company$ | async; as company) {
  <div class="breadcrumb-wrapper">
    <nav class="breadcrumb !m-0">
      <span class="material-symbols-rounded text-[#36442A]">groups</span>
      <div class="flex items-center gap-2">
        <a routerLink="/admin/companies" class="breadcrumb-link">{{
          "admin.companyDetails.breadcrumb" | translate
        }}</a>
        <span class="text-[#8E96A3]">/</span>
        <span class="breadcrumb-current">{{
          "admin.companyDetails.breadcrumbCurrent" | translate
        }}</span>
      </div>
    </nav>

    <div class="flex items-center gap-2">
      @if (isFilterApplied) {
        <button
          (click)="clearFilters()"
          class="text-sm text-[#6A7381] hover:underline"
        >
          {{ "admin.companyDetails.clearFilter" | translate }}
        </button>
      }
      <button
        class="flex items-center gap-2 border text-[#6A7381] border-[#6A7381] rounded-md px-2 text-sm"
        (click)="downloadStatsCsv()"
        [disabled]="isDownloadingStatsCsv$ | async"
      >
        <p class="!m-0">{{ "admin.dashboard.downloadCsv" | translate }}</p>
        @if (isDownloadingStatsCsv$ | async) {
          <span
            class="loader-border w-4 h-4 border-2 border-t-transparent rounded-full animate-spin"
          ></span>
        } @else {
          <span class="material-symbols-rounded text-[#5b774a] scale-90">
            download
          </span>
        }
      </button>
      <div class="relative w-52">
        <input
          (change)="onDateRangeChange($event)"
          [alwaysShowCalendars]="true"
          [autoApply]="true"
          [linkedCalendars]="true"
          [locale]="datepickerLocale"
          [showCancel]="false"
          [showClearButton]="true"
          [showDropdowns]="true"
          [opens]="'left'"
          [drops]="'down'"
          class="form-control cursor-pointer w-full border rounded text-sm"
          ngxDaterangepickerBootstrap
          placeholder="{{ 'admin.companyDetails.filterByDate' | translate }}"
          readonly
          type="text"
        />
        <div
          class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
        >
          <span class="material-symbols-rounded scale-75 text-[#6A7381]"
            >date_range</span
          >
        </div>
      </div>
    </div>
  </div>
  <div class="company-container">
    <div class="company-details-container">
      <div class="company-header">
        <div class="company-info">
          <div class="company-info-top">
            <div class="flex flex-col gap-2">
              <p class="name">{{ company.name }}</p>
              <div class="user-meta">
                <div class="flex gap-2">
                  <p>CNPJ:</p>
                  <p class="profile">{{ formatCnpj(company.cnpj) }}</p>
                </div>
                <div class="flex gap-2">
                  <p>{{ "admin.companyDetails.code" | translate }}:</p>
                  <p class="profile">{{ company.lmCode }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="user-meta">
            @if (companyStats$ | async; as companyStats) {
              @if (companyBilling$ | async; as companyBilling) {
                <div class="meta-item !justify-between lg:col-span-2">
                  <div class="flex items-center justify-start !gap-4">
                    <span
                      class="material-symbols-rounded card-icon bg-[#e9fae8] text-[#157811]"
                    >
                      paid
                    </span>
                    <div>
                      <div class="flex items-center gap-3">
                        <p class="value !m-0">
                          {{
                            companyBilling.billing.totalPrice
                              | currency
                                : currencyCode
                                : "symbol"
                                : "1.2-2"
                                : currentLang
                          }}
                        </p>
                        <span
                          class="border px-1 border-solid border-[#6A7381] text-[#6A7381] rounded-md"
                          >{{ companyBilling.fileCount }}
                          {{
                            "admin.dashboard.cards.billing.files" | translate
                          }}</span
                        >
                      </div>
                      <span class="label"
                        >{{
                          "admin.companyDetails.billing.totalPrice" | translate
                        }}
                        ({{ companyBilling.startDate | date: "dd/MM/yyyy" }} -
                        {{ companyBilling.endDate | date: "dd/MM/yyyy" }})</span
                      >
                    </div>
                  </div>
                  <button
                    (click)="downloadCompanyBillingCsv()"
                    [disabled]="isDownloadingBillingCsv$ | async"
                    class="flex items-center gap-2 border text-[#6A7381] border-[#6A7381] rounded-md px-2 text-sm self-start justify-self-end"
                  >
                    <p class="!m-0">
                      {{ "admin.companies.downloadCsv" | translate }}
                    </p>
                    @if (isDownloadingBillingCsv$ | async) {
                      <span
                        class="loader-border w-4 h-4 border-2 border-t-transparent rounded-full animate-spin"
                      ></span>
                    } @else {
                      <span
                        class="material-symbols-rounded text-[#5b774a] scale-90"
                      >
                        download
                      </span>
                    }
                  </button>
                </div>
                <div class="meta-item lg:col-span-2">
                  <span
                    class="material-symbols-rounded card-icon bg-[#fae6e6] text-[#cf1f00]"
                  >
                    counter_1
                  </span>
                  <div>
                    <p class="value !m-0">
                      {{
                        companyBilling.billing.pricePerFile
                          | currency
                            : currencyCode
                            : "symbol"
                            : "1.2-2"
                            : currentLang
                      }}
                    </p>
                    <span class="label"
                      >{{
                        "admin.companyDetails.billing.unitaryPrice" | translate
                      }}
                      ({{ companyBilling.startDate | date: "dd/MM/yyyy" }} -
                      {{ companyBilling.endDate | date: "dd/MM/yyyy" }})</span
                    >
                  </div>
                </div>
              }
              <div class="meta-item">
                <span
                  class="material-symbols-rounded card-icon bg-blue text-blue"
                >
                  groups
                </span>
                <div>
                  <p class="value !m-0">{{ company.activeUsersCount }}</p>
                  <span class="label">{{
                    "admin.companyDetails.activeUsers" | translate
                  }}</span>
                </div>
              </div>
              <div class="meta-item">
                <span
                  class="material-symbols-rounded card-icon bg-green text-green"
                >
                  task_alt
                </span>
                <div>
                  <p class="value !m-0">{{ companyStats.files.length }}</p>
                  <span class="label">{{
                    "admin.companyDetails.totalConvertedFiles" | translate
                  }}</span>
                </div>
              </div>
              <div class="meta-item">
                <img
                  src="assets/images/Gerber1 1 1.svg"
                  alt=""
                  class="card-icon bg-blue"
                />
                <div>
                  <p class="value !m-0">{{ companyStats.gerberCount }}</p>
                  <span class="label">{{
                    "admin.companyDetails.gerberFiles" | translate
                  }}</span>
                </div>
              </div>
              <div class="meta-item">
                <img
                  src="assets/images/lectra-icon 1.svg"
                  alt=""
                  class="card-icon bg-red"
                />
                <div>
                  <p class="value !m-0">{{ companyStats.lectraCount }}</p>
                  <span class="label">{{
                    "admin.companyDetails.lectraFiles" | translate
                  }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      @if (companyStats$ | async; as stats) {
        @if (chartData$ | async; as chart) {
          <div class="charts-container">
            <app-chart-card
              class="chart-donut"
              [data]="[stats.gerberCount, stats.lectraCount]"
              [labels]="['Gerber', 'Lectra']"
              [title]="'admin.companyDetails.chart.totalByType' | translate"
              [defaultType]="'donut'"
              [showTypeSwitcher]="true"
              [distributed]="true"
            />

            <app-chart-card
              class="chart-bar"
              [series]="chart.series"
              [labels]="chart.labels"
              [title]="'admin.companyDetails.chart.byPeriod' | translate"
              [defaultType]="'bar'"
              [distributed]="false"
            />
          </div>
        }
      }

      <!--<div class="recent-activity">
      <p>Recent Conversions</p>
      @if (dashboardStats$ | async; as stats) {
        <ul>
          @for (recentFile of stats.recentFiles; track $index) {
            <li>
              {{ dateUtils.formatIsoToDateTime(recentFile.createdAt) }}:
              <strong> {{ recentFile.userName }}</strong> converted
              {{ recentFile.fileType }} file
              <em
                ><strong>{{ recentFile.originalFileName }}</strong></em
              >
            </li>
          }
        </ul>
      }
    </div>-->
    </div>
  </div>
}
